import Header from '@components/Header';
import TabItem from '@components/tab/TabItem';
import TabList from '@components/tab/TabList';
import { useStepFlow } from '@router/stackflow';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';

import EventList from './components/EventList';
import NoticeList from './components/NoticeList';

interface Params {
    type: 'EVENT' | 'NOTICE';
}

const BoardActivity: ActivityComponentType<Params> = ({ params }:{params: Params}) => {
  const { type } = params;
  const { stepReplace } = useStepFlow('BoardActivity');
  return (
      <AppScreen>
          <Header title='새소식' />
          <TabList variant='solid'>
              <TabItem selected={type === 'EVENT'}
                       onClick={() => stepReplace({ type: 'EVENT' })}>
                  이벤트
              </TabItem>
              <TabItem selected={type === 'NOTICE'}
                       onClick={() => stepReplace({ type: 'NOTICE' })} >
                  공지사항
              </TabItem>
          </TabList>
          {type === 'EVENT' && (
              <EventList/>
          )}
          {type === 'NOTICE' && (
              <NoticeList/>
          )}
      </AppScreen>
  );
};

export default BoardActivity;
